import { useEffect, useState } from 'react'

import { useTagStore } from '@modules/Tag/Presentation/store/TagStore'

import { BusinessUnit, BrandLogos } from '@shared/constants/brands'
import Edition from '@modules/Edition/Domain/Edition'

import Container from '@shared/Presentation/components/common/Container'
import EditionCheckbox from '@shared/Presentation/components/common/card/edition/EditionCheckbox'
import Picture from '@shared/Presentation/components/common/Picture'
import Text from '@shared/Presentation/components/common/Text'

type TEditionCardWithCheckbox = {
  edition: Edition
}

const EditionCardWithCheckbox: React.FC<TEditionCardWithCheckbox> = ({ edition }) => {
  const [checked, setChecked] = useState<boolean>(false)
  const { tags, setTag, removeTag } = useTagStore()

  useEffect(() => {
    if (!tags.length) {
      setChecked(false)
    }
  }, [tags])

  const handleClick = (data) => {
    const { checked } = data
    if (checked) {
      edition.tags.map(tag => setTag(tag.name))
      setChecked(checked)
    } else {
      edition.tags.map(tag => removeTag(tag.name))
      setChecked(checked)
    }
  }

  return (
    <Container className='flex items-center justify-between p-5'>
      <Picture
        src={BrandLogos[edition.businessUnit]}
        size={edition.businessUnit === BusinessUnit.AS ? 'mini' : 'tiny'}
      />
      <div>
        <Text className='block font-semibold'>{edition.prettyName}</Text>
        {
          (edition.businessUnit === BusinessUnit.EP || edition.businessUnit === BusinessUnit.EP_AMERICA) && (
            <Text className='block mt-1 text-gray-500 text-[10px] italic underline uppercase tracking-widest'>Canal: {edition.tags[0].prettyName}</Text>
          )
        }
      </div>
      <EditionCheckbox 
        checked={checked}
        onClick={(e, data) => handleClick(data)}
      />
    </Container>
  )
}

export default EditionCardWithCheckbox